import { baseApi } from '@/lib/store/api/baseQuery'
import { apiEndpoints } from '@/lib/api/endpoints'

export type PartnerConsentsMatrix = Record<string, Record<string, boolean>>

export const partnerConsentsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getPartnerConsents: builder.query<PartnerConsentsMatrix, void>({
            query: () => apiEndpoints.partnerConsents.get,
            providesTags: ['PartnerConsents'],
        }),
        revokePartnerConsents: builder.mutation<PartnerConsentsMatrix, { partnerName: string; consents: string[] }>({
            query: ({ partnerName, consents }) => ({
                url: apiEndpoints.partnerConsents.revoke(partnerName),
                method: 'PATCH',
                body: { consents },
            }),
            invalidatesTags: ['PartnerConsents'],
        }),
    }),
    overrideExisting: false,
})

export const { useGetPartnerConsentsQuery, useRevokePartnerConsentsMutation } = partnerConsentsApi
